/* Foodkind web components v2 — delivery checker, sticky ATC, ⌘K search, email popup */
class DeliveryChecker extends HTMLElement {
  connectedCallback() {
    const saved = localStorage.getItem('fk-postal');
    this.innerHTML = `
      <form class="fk-dc" autocomplete="off">
        <input class="fk-dc__input" type="text" maxlength="10" placeholder="Enter ZIP or postal code" aria-label="Delivery ZIP or postal code" value="${saved || ''}">
        <button class="fk-dc__btn" type="submit">Check</button>
      </form>
      <p class="fk-dc__msg" role="status" aria-live="polite"></p>`;
    const form = this.querySelector('form'), input = this.querySelector('input'), msg = this.querySelector('.fk-dc__msg');
    const re = /^(\d{5}(-\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d)$/;
    const show = (m, ok) => { msg.textContent = m; msg.dataset.ok = ok ? '1' : '0'; };
    if (saved) show('✓ We deliver fresh-frozen to your door — cold-chain guaranteed.', true);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = input.value.trim();
      if (!re.test(v)) { show('Please enter a valid US ZIP or Canadian postal code.', false); return; }
      localStorage.setItem('fk-postal', v.toUpperCase());
      show('✓ Cold-chain delivery to your door — free on boxes $99+.', true);
    });
  }
}
customElements.define('delivery-checker', DeliveryChecker);

class StickyAtc extends HTMLElement {
  connectedCallback() {
    const target = document.querySelector('product-form .shopify-payment-button, .fk-buybox, form[action*="/cart/add"]');
    if (!target) return;
    const price = document.querySelector('[data-price], .price__container .price-item--regular, [class*="price"]')?.textContent?.trim().slice(0, 14) || '';
    this.innerHTML = `<div class="fk-sticky-atc"><span class="fk-sticky-atc__price">${price}</span><button class="fk-sticky-atc__btn" type="button">Add to cart</button></div>`;
    this.querySelector('button').addEventListener('click', () => document.querySelector('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"], .fk-buybox button')?.click());
    new IntersectionObserver(([e]) => this.classList.toggle('fk-sticky-atc--visible', !e.isIntersecting), { threshold: 0 }).observe(target);
  }
}
customElements.define('sticky-atc', StickyAtc);

/* ⌘K / Ctrl+K predictive search shortcut */
document.addEventListener('keydown', (e) => {
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
    e.preventDefault();
    const trigger = document.querySelector('details-modal summary, [data-predictive-search-trigger], header search, .header .search');
    if (trigger) { trigger.click?.(); trigger.querySelector?.('input, button')?.click?.(); }
    else { window.location.href = '/search'; }
  }
});

/* Email popup moved to sections/fk-email-popup.liquid (real Shopify newsletter capture).
   The old JS popup here used preventDefault() — it never captured a single email. */
